import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { languages } from '../data';
import { TranslationService } from '../services/translation.service';
import { environment } from '../../environments/environment';


@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, TranslateModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  languages = languages;

  baseApiUrl = environment.baseApiUrl;

  constructor(private translate: TranslateService, private translationService: TranslationService) {
    translate.setDefaultLang('en');
  }

  changeLang(lang: string) {
    this.translationService.changeLang(lang);
  }
}
